export enum ApplicationScreen {
	AdminBannedPatient = "Admin.BannedPatient",
	AdminClinicSettings = "Admin.ClinicSettings",
	AdminTelehealthCentre = "Admin.TelehealthCentre",
	AdminMobileCheckIn = "Admin.MobileCheckIn",
	AdminTelehealthQueue = "Admin.TelehealthQueue",
	AdminTelehealthDoctor = "Admin.TelehealthDoctor",
	AdminCentreOperations = "Admin.CentreOperations",
	AdminTelehealthScheule = "Admin.TelehealthScheule"
}
export interface CreateAuditLogRequest {
	clinicId?: number;
	doctorId?: number;
	doctorName?: string;
	patientId?: number;
	patientName?: string;
	username: string;
	applicationScreen: ApplicationScreen;
	action: string;
	fromValue?: string;
	toValue?: string;
}

export interface AuditLog {
	id: number;
	clinicId?: number;
	clinicName: string;
	doctorId?: number;
	doctorName: string;
	patientId?: number;
	patientName: string;
	username: string;
	applicationScreen: ApplicationScreen;
	action: string;
	fromValue: string;
	toValue: string;
	createdOn: string;
}

export interface AuditLogSearch {
	clinicId: number;
	doctorId?: number;
	patientId?: number;
	patientName?: string;
	username: string;
	applicationScreen: string;
	action: string;
	fromDate?: string;
	toDate?: string;
}

export interface PatientSearchResponse {
	patientId: number;
	patientName: string;
}

export interface DoctorSearchResponse {
	doctorId: number;
	doctorName: string;
}
